import type { FC } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { ShopTeaser as UIShopTeaser } from "@jti/ui/eva-components/Header/components/SecondaryNavigation/components/ShopTeaser/ShopTeaser";
import { ShopTeaser as MobileFirstUIShopTeaser } from "@jti/ui/eva-components/MobileFirstHeader/components/SecondaryNavigation/components/ShopTeaser";

import type { ShopTeaserProps } from "./ShopTeaser.builder";

export const ShopTeaser: FC<ShopTeaserProps> = ({ topText, theme, ...props }) => {
  const { isMobileFirstNavigationEnabled } = useConfig();
  const ShopTeaserComponent = isMobileFirstNavigationEnabled ? MobileFirstUIShopTeaser : UIShopTeaser;

  // change topText to bottomText once content migration is possible through migration scripts
  return <ShopTeaserComponent theme={theme} {...props} bottomText={topText} />;
};
